const initialValues = {
  first_name: "",
  last_name: "",
  phone: "",
  email: "",
  status: 1,
};

export default initialValues;
